import { LoaderFunctionArgs } from "react-router";

// Session state is live only inside SessionProvider. A loader could rehydrate a
// storage snapshot, but it would miss polling-driven onboarding promotion until
// another navigation revalidated it. RouteAccessGuard owns those redirects.
export default async function rootLoader(_args: LoaderFunctionArgs) {
  return null;
}
